(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["footer-blocks"] && !Shopify.designMode) return;
  try {
    document.addEventListener('click',async function(event){
  const button=event.target.closest('.bhe-footer-cookie-button');
  if(!button)return;
  const error=button.closest('.bhe-cookie-settings').querySelector('.bhe-footer-cookie-error');
  error.hidden=true;
  try{
    if(!window.privacyBanner?.showPreferences)throw new Error('unavailable');
    await window.privacyBanner.showPreferences();
  }catch{error.hidden=false;}
});
  } catch(e) { console.error(e); }
})();

})();
